export default "__VITE_ASSET__CyUfWhOL__"